import type { PublicLeaderboard } from '../../../domain/leaderboard/models/public-leaderboard.model';
import { computeLeaderboardProgressPercent } from '../../../domain/leaderboard/utils/compute-leaderboard-progress-percent';

/** Stub data for development until the public leaderboard API exists. */
export function createStubPublicLeaderboard(overrides: Partial<PublicLeaderboard> = {}): PublicLeaderboard {
  const base: PublicLeaderboard = {
    boardId: 'lb-demo',
    title: 'Leaderboard',
    status: 'active',
    activityType: 'competitive',
    summary: {
      participantsCount: 4567,
      totalXp: 1027575,
      activityType: 'competitive',
      winnersStatLabel: 'GANADORES',
      winnersLabel: 'Top 50',
    },
    prizes: [
      {
        id: 'p1',
        isFeatured: true,
        title: 'Premio Principal - Top 50',
        description:
          'Gasolina gratis por un año (hasta 100 galones mensuales) + Kit premium + Lavado de auto ilimitado',
        xpRequired: 50000,
      },
      {
        id: 'p2',
        isFeatured: false,
        title: 'Bonificación de puntos - 1.000 pts',
        description: '3.245 participantes lo alcanzaron',
        xpRequired: 1000,
        participantsReachedLabel: '3.245 participantes lo alcanzaron',
      },
      {
        id: 'p3',
        isFeatured: false,
        title: 'Bonificación de puntos - 2.500 pts',
        description: '2.100 participantes lo alcanzaron',
        xpRequired: 2500,
        participantsReachedLabel: '2.100 participantes lo alcanzaron',
      },
    ],
    podium: [
      { rank: 2, label: 'Valentina M.', xp: 14944 },
      { rank: 1, label: 'Carlos M.', xp: 16545 },
      { rank: 3, label: 'Andrés M.', xp: 14045 },
    ],
    ranking: buildRankingRows(),
    lastUpdatedIso: '2026-04-10T12:00:00.000Z',
    footerHint: 'Actualizado en tiempo real',
  };
  return {
    ...base,
    ...overrides,
    summary: { ...base.summary, ...overrides.summary },
  };
}

function buildRankingRows(): PublicLeaderboard['ranking'] {
  const rows = [
    { rank: 1, anonymousId: '42891', xp: 16545, isWinner: true },
    { rank: 2, anonymousId: '55102', xp: 14944, isWinner: true },
    { rank: 3, anonymousId: '66321', xp: 14045, isWinner: true },
    { rank: 4, anonymousId: '77412', xp: 13200, isWinner: false },
    { rank: 5, anonymousId: '88503', xp: 12100, isWinner: false },
    { rank: 6, anonymousId: '99614', xp: 11050, isWinner: false },
  ];
  const leaderXp = rows.find((r) => r.rank === 1)?.xp ?? 0;
  return rows.map((r) => ({
    ...r,
    progressPercent: computeLeaderboardProgressPercent(r.xp, leaderXp),
  }));
}
